import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    "aria-label": "breadcrumb",
    class: _normalizeClass(props.class)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})